"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageTransferDesc = void 0;
const getPackageTransferDesc = (pkg) => {
    if (pkg.airport_transfer && pkg.course_transfer) {
        return "You will be met on arrival at the airport and transferred to your hotel, and then back to the airport at the end of your trip. This package also includes transport to and from each golf course in a private vehicle.";
    }
    else {
        if (pkg.airport_transfer) {
            return "You will be met on arrival at the airport and transferred to your hotel, and then back to the airport at the end of your trip. ";
        }
        else if (pkg.course_transfer) {
            return "This package includes transport to and from each golf course in a private vehicle.";
        }
    }
};
exports.getPackageTransferDesc = getPackageTransferDesc;
